import React, { useState } from "react";
import Tooltip from "react-tooltip";
import PatientFiWalletModal from "./PatientFiWalletModal";
import { formatCurrency } from "../../../../../utilities/general";
import { CircularProgress } from "../../../../../shared/CircularProgress/CircularProgress";
import { uiNotification } from "../../../../../services/UINotificationService";

const ClientWalletPatientFi = ({ data, reload }) => {
  const [showModal, setShowModal] = useState(false);
  const [isReloading, setIsReloading] = useState(false);

  const availableBalance = data?.profile?.availableBalance || 0;
  const isApproved = data?.profile?.status?.toLowerCase() === "approved";
  const denialReason = data?.profile?.denialReason || null;

  return (
    <>
      <tr className="table-updated-tr">
        <td className="col-xs-5 table-updated-td bold flex gap-8 items-center">
          <span>PatientFi</span>
          {!isApproved && (
            <div data-tip data-for="denialReason">
              <i
                className="fa fa-exclamation-circle"
                style={{ color: "red" }}
              ></i>
            </div>
          )}
          {denialReason && (
            <Tooltip id="denialReason" aria-haspopup="true" place="right">
              {denialReason}
            </Tooltip>
          )}
        </td>
        <td className="col-xs-2 table-updated-td text-right"></td>
        <td className="col-xs-2 table-updated-td text-right">
          {formatCurrency(availableBalance)}
        </td>
        <td className="col-xs-3 table-updated-td text-center">
          {data.isEnrolled ? (
            isReloading ? (
              <CircularProgress className="m-0-auto" size="small" />
            ) : (
              <button
                className="easy-link text-no-wrap no-padding"
                onClick={() => {
                  setIsReloading(true);
                  reload()
                    .then(() =>
                      uiNotification.success(
                        "PatientFi Wallet Reloaded Successfully!",
                      ),
                    )
                    .finally(() => setIsReloading(false));
                }}
              >
                Reload
              </button>
            )
          ) : (
            <button
              className="easy-link text-no-wrap"
              onClick={() => setShowModal(true)}
            >
              Enroll
            </button>
          )}
        </td>
      </tr>
      {showModal && (
        <PatientFiWalletModal onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

export default ClientWalletPatientFi;
